import { render, staticRenderFns } from "./UserPopup.vue?vue&type=template&id=85e0c992&scoped=true"
import script from "./UserPopup.vue?vue&type=script&lang=js"
export * from "./UserPopup.vue?vue&type=script&lang=js"
import style0 from "./UserPopup.vue?vue&type=style&index=0&id=85e0c992&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e0c992",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85e0c992')) {
      api.createRecord('85e0c992', component.options)
    } else {
      api.reload('85e0c992', component.options)
    }
    module.hot.accept("./UserPopup.vue?vue&type=template&id=85e0c992&scoped=true", function () {
      api.rerender('85e0c992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/users/UserPopup.vue"
export default component.exports